import type { BrokerProcessStepEnum, CustomerApplicationProcessStepEnum } from '@/types';

/**
 * Canonical wizard step names written to application_draft_events.
 * Mirrors the backend ApplicationDraftEventName enum.
 */
export const DraftEventName = {
  StartApplication: 'start_application',
  SelectCustomerType: 'select_customer_type',
  LoanPurpose: 'loan_purpose',
  PropertyDetails: 'property_details',
  PropertyDetailsBuying: 'property_details_buying',
  PropertyDetailsSelling: 'property_details_selling',
  LoanDetails: 'loan_details',
  ExitStrategy: 'exit_strategy',
  PersonalDetailsCompleted: 'personal_details_completed',
  PropertyOwnership: 'property_ownership',
  Summary: 'summary',
  Income: 'income',
  SummaryIncome: 'summary_income',
  Expenses: 'expenses',
  Assets: 'assets',
  VerifyIdentity: 'verify_identity',
  Submitted: 'submitted',
} as const;

export type DraftEventNameValue = (typeof DraftEventName)[keyof typeof DraftEventName];

export const customerStepToDraftEvent: Partial<Record<CustomerApplicationProcessStepEnum, DraftEventNameValue>> = {
  selectLoanType: DraftEventName.StartApplication,
  loanDetails: DraftEventName.LoanDetails,
  incomingProperties: DraftEventName.PropertyDetailsBuying,
  outgoingProperties: DraftEventName.PropertyDetailsSelling,
  applicantDetails: DraftEventName.PersonalDetailsCompleted,
  propertyOwnership: DraftEventName.PropertyOwnership,
  income: DraftEventName.Income,
  expenses: DraftEventName.Expenses,
  assets: DraftEventName.Assets,
  verification: DraftEventName.VerifyIdentity,
  submitApplication: DraftEventName.Submitted,
};

export const brokerStepToDraftEvent: Partial<Record<BrokerProcessStepEnum, DraftEventNameValue>> = {
  brokerSelectLoanType: DraftEventName.StartApplication,
  brokerPropertyDetails: DraftEventName.PropertyDetails,
  brokerLoanPurpose: DraftEventName.LoanPurpose,
  brokerLoanDetails: DraftEventName.LoanDetails,
  brokerExitStrategy: DraftEventName.ExitStrategy,
  brokerApplicantDetails: DraftEventName.PersonalDetailsCompleted,
  brokerPropertyOwnership: DraftEventName.PropertyOwnership,
  brokerIncome: DraftEventName.Income,
  brokerExpenses: DraftEventName.Expenses,
  brokerAssets: DraftEventName.Assets,
  brokerSubmitApplication: DraftEventName.Submitted,
};
